import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custom-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-pagination.component.html',
  styleUrl: './custom-pagination.component.scss'
})
export class CustomPaginationComponent implements OnChanges {

  @Input() filter: any = {
    page: 1,
    limit: 10
  }

  @Input() total: number = 0

  @Output() savePage = new EventEmitter()

  totalPages: number = 0
  pages: number[] = []

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['total'] || changes['filter']) {
      this.recalculate();
    }
  }

  private recalculate(): void {
    this.totalPages = this.total === 0 ? 0 : Math.ceil(this.total / this.filter.limit);
    this.pages = Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  updatePage(page: number) {
    this.filter.page = page;
    this.savePage.emit({ page: this.filter.page });
  }
}
